import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Buffer } from 'buffer';



import { AuthProvider } from "./state/context/auth.context.js";
import { WalletsProvider } from "./state/context/wallets.context.js";
import { TasksProvider } from "./state/context/tasks.context.js";
import { BitcoinPriceProvider } from './state/context/bitcoin.context.js';


window.Buffer = Buffer;


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BitcoinPriceProvider>
      <AuthProvider>
        <WalletsProvider>
          <TasksProvider>
            <App />

          </TasksProvider>
        </WalletsProvider>
      </AuthProvider>
    </BitcoinPriceProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
